export const VendorNotificationTypes = {
    "EXPIRED": 2,
    "EXPIRING_SOON": 1,
    "GOOD": 0
}